angular.module('MyApp')

  .controller('ProfileCtrl', function ($rootScope, $scope, $auth, toastr, Account, services, $location) {
    $scope.url_ = $rootScope.url_;

    $rootScope.menu1 = 50;

    if ($rootScope.user.token.length > 0) {
      $scope.user = { 'token': $rootScope.user.token, 'mail': $rootScope.user.mail, 'nom': $rootScope.user.nom };
      $scope.OldPassword = "";
    } else {
      $scope.user = { 'token': "", 'mail': "", 'id': "", 'nom': "" };
    }


    $scope.getProfile = function () {
      $scope.user = { 'token': $rootScope.user.token, 'mail': $rootScope.user.mail, 'nom': $rootScope.user.nom };
      //$scope.user = {'token': sessionStorage.getItem("token"),'email': sessionStorage.getItem("mail"), 'id': sessionStorage.getItem("id"), 'nom': sessionStorage.getItem("nom") };
    };

    $scope.go = function (ad) {
      if (ad == 'mdp') $location.path("/mdp");
      else if (ad == 'home') $location.path('/0lst');

    };

    /*
    $scope.gotoMDP = function() {
      parent.location='/mdp'
    };
    */

    $scope.changerMDP = function () {

      services.modifMDP({ 'mail': $scope.user.mail, 'amdp': $scope.OldPassword, 'nmdp1': $scope.NewPassword, 'nmdp2': $scope.confirmPassword, 'nom': $scope.user.nom })
        .then(function (data) {
          setTimeout(function () {
            toastr.success('___mot de passe modifié___');
            $location.path('/');//document.location.href
          }, 350);

        })
        .catch(function (response) {
          toastr.error(response.data.message, response.status);
        });


    };

    $scope.link = function (provider) {
      $auth.link(provider)
        .then(function () {
          toastr.success('You have successfully linked a ' + provider + ' account');
          $scope.getProfile();
        })
        .catch(function (response) {
          toastr.error(response.data.message, response.status);
        });
    };


    $scope.unlink = function (provider) {
      $auth.unlink(provider)
        .then(function () {
          toastr.info('You have unlinked a ' + provider + ' account');
          $scope.getProfile();
        })
        .catch(function (response) {
          toastr.error(response.data ? response.data.message : 'Could not unlink ' + provider + ' account', response.status);
        });
    };


    $scope.getProfile();

  });